module.exports = __webpack_public_path__ + "img/27_73.50b986f8.png";